import { Sparkles, Share2, Layers, TrendingUp } from 'lucide-react';
import { Logo, LogoMark } from './Logo';

const FEATURES = [
  { icon: Sparkles, title: 'Conteúdo com IA por marca', desc: 'Cada empresa com seu GPT e identidade visual.' },
  { icon: Share2, title: 'Publique em todas as redes', desc: 'Facebook, Instagram, LinkedIn, X e TikTok.' },
  { icon: Layers, title: '10 projetos, 1 pessoa', desc: 'Gere em lote, aprove e agende rápido.' },
  { icon: TrendingUp, title: 'Acompanhe o engajamento', desc: 'Melhores horários e o que realmente funciona.' }
];

export default function AuthLayout({ children }) {
  return (
    <div className="auth-split">
      <aside className="auth-brand">
        <div className="ab-logo"><Logo /></div>
        <div className="ab-content">
          <h2>O pulso das suas redes, num só lugar.</h2>
          <p className="lead">Crie, agende e publique conteúdo de várias marcas com IA — do jeito certo, na hora certa.</p>
          <div className="auth-feats">
            {FEATURES.map((f) => {
              const Icon = f.icon;
              return (
                <div key={f.title} className="auth-feat">
                  <span className="fi"><Icon size={19} /></span>
                  <span><strong>{f.title}</strong><span>{f.desc}</span></span>
                </div>
              );
            })}
          </div>
        </div>
      </aside>

      <main className="auth-panel">
        <div className="auth-form">
          <div className="auth-mobile-logo"><LogoMark size={30} /><span style={{ fontSize: 20, fontWeight: 700 }}>Pulso</span></div>
          {children}
        </div>
      </main>
    </div>
  );
}
